










import { Component, Prop, Vue } from 'vue-property-decorator';
import Spinner from '@/components/Spinner.vue';

export type StatusData = {
  title?: string;
  message?: string;
  spinner?: boolean;
};

@Component({
  components: {
    Spinner
  }
})
export default class Status extends Vue {
  @Prop() data?: StatusData;
}
